import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';

import './assets/editor.css';

const productTabIcon = (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.5 11.25C4.79688 11.224 4.21094 10.9766 3.74219 10.5078C3.27344 10.0391 3.02604 9.45312 3 8.75V6.25C3.02604 5.54688 3.27344 4.96094 3.74219 4.49219C4.21094 4.02344 4.79688 3.77604 5.5 3.75H20.5C21.2031 3.77604 21.7891 4.02344 22.2578 4.49219C22.7266 4.96094 22.974 5.54688 23 6.25V8.75C22.974 9.45312 22.7266 10.0391 22.2578 10.5078C21.7891 10.9766 21.2031 11.224 20.5 11.25H5.5ZM23 18.75C22.974 19.4531 22.7266 20.0391 22.2578 20.5078C21.7891 20.9766 21.2031 21.224 20.5 21.25H5.5C4.79688 21.224 4.21094 20.9766 3.74219 20.5078C3.27344 20.0391 3.02604 19.4531 3 18.75V16.25C3.02604 15.5469 3.27344 14.9609 3.74219 14.4922C4.21094 14.0234 4.79688 13.776 5.5 13.75H20.5C21.2031 13.776 21.7891 14.0234 22.2578 14.4922C22.7266 14.9609 22.974 15.5469 23 16.25V18.75ZM20.5 15.625H5.5C5.10938 15.651 4.90104 15.8594 4.875 16.25V18.75C4.90104 19.1406 5.10938 19.349 5.5 19.375H20.5C20.8906 19.349 21.099 19.1406 21.125 18.75V16.25C21.099 15.8594 20.8906 15.651 20.5 15.625Z"
            fill="#FD5162"
        />
    </svg>
);

registerBlockType(metadata.name, {
    icon: productTabIcon,
    title: metadata.title,
    edit: Edit,
});
